export default function () {
  return {
    cameraTimeline: '',
    clientData: ''
  }
}
